import React, {FC} from 'react'
import {useForm, FieldErrors, Controller} from 'react-hook-form'
import Select from 'react-select'
type InputProps = {
  data: any[]
  name: string
  value?: string
  style?: any
  errors: FieldErrors
  control: ReturnType<typeof useForm>['control'] // Declaramos control en la interfaz
  onChangeValue?: (e: any) => void
  disabled?: boolean
  getOptionLabel?: (option: any) => string
  isMulti?: boolean
}

const SelectComponent: FC<InputProps> = ({
  name,
  value,
  data,
  control,
  errors,
  disabled,
  onChangeValue,
  style,
  getOptionLabel,
  isMulti = false,
  ...props
}) => {
  return (
    <div className='sdx_form_input '>
      {onChangeValue ? (
        <Controller
          control={control}
          name={name}
          render={({field}) => (
            <Select
              {...field}
              key={field.value}
              className='react-select-container'
              classNamePrefix='react-select'
              placeholder='Selecciona una opción'
              options={data}
              styles={style}
              noOptionsMessage={() => 'No hay resultados'}
              value={data?.find((c: {value: string}) => c.value === field.value)}
              onChange={(val) => onChangeValue(val)}
              getOptionLabel={getOptionLabel}
              isDisabled={disabled}
            />
          )}
        />
      ) : isMulti ? (
        <Controller
          control={control}
          name={name}
          render={({field}) => (
            <Select
              {...field}
              key={field.value}
              className='react-select-container'
              classNamePrefix='react-select'
              options={data}
              noOptionsMessage={() => 'No hay resultados'}
              placeholder='Selecciona una opción'
              styles={style}
              // value={data?.find((c: {value: string}) => c.value === field.value)}
              onChange={(val) => field.onChange(val)}
              isDisabled={disabled}
              getOptionLabel={getOptionLabel}
              isMulti={isMulti}
            />
          )}
        />
      ) : (
        <Controller
          control={control}
          name={name}
          render={({field}) => (
            <Select
              {...field}
              key={field.value}
              className='react-select-container'
              classNamePrefix='react-select'
              options={data}
              noOptionsMessage={() => 'No hay resultados'}
              placeholder='Selecciona una opción'
              styles={style}
              value={data?.find((c: {value: string}) => c.value === field.value)}
              onChange={(val) => field.onChange(val ? val.value : '')}
              isDisabled={disabled}
              getOptionLabel={getOptionLabel}
            />
          )}
        />
      )}

      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default SelectComponent
